import React, { useState } from 'react';
import {
    ModalContainer,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalFormLabel,
    ModalForm,
    ModalTextArea,
    ModalCloseButton,
    ModalButton,
    BetaModalOverlay,
    ArrowForward,
    ArrowRight
} from './BetaModalElements';

const BetaModal = ({ isOpen, onClose }) => {
    const [hover, setHover] = useState(false);

    const onHover = () => {
        setHover(!hover);
    };


    if (!isOpen) return null;



    return (
        <BetaModalOverlay>
            <ModalContainer>
                <ModalHeader>Hey there!</ModalHeader>
                <ModalBody>We're thrilled to have you on our journey. Just a heads-up, the product you're exploring is still a work in progress. You might notice some quirks or areas that need a bit of polish. We're working hard to make it the best it can be, but great things take time. Your patience means the world to us, and we're so grateful for your support and feedback. Together, we're building something amazing!</ModalBody>
                <ModalFooter>
                    <ModalCloseButton onClick={onClose}>Cancel</ModalCloseButton>
                    <ModalButton
                        to='/mylibrary'>
                        Proceed
                    </ModalButton>
                </ModalFooter>
            </ModalContainer>
        </BetaModalOverlay>
    );
};


export default BetaModal;
